import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-button',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.css'],
})
export class ButtonComponent implements OnInit {
    @Input() label = 'Button';
    @Input() type: 'button' | 'submit' | 'reset' = 'button';
    @Input() variant:
        | 'primary'
        | 'secondary'
        | 'outline-secondary'
        | 'success'
        | 'danger'
        | 'warning'
        | 'info'
        | 'light'
        | 'dark'
        | 'link' = 'primary';
    @Input() size: 'sm' | 'md' | 'lg' = 'md';
    @Input() disabled = false;
    @Input() extraClasses = '';
    @Input() stopPropagation = false;
    @Input() ariaLabel = '';
    @Input() iconClass = '';
    @Input() iconOnly = false;

    @Output() clicked = new EventEmitter<MouseEvent>();


    ngOnInit(): void {
        if(this.variant =='secondary'){
            this.variant = 'outline-secondary';
        }
    }
    onClick(event: MouseEvent) {
        if (this.stopPropagation) event.stopPropagation();
        this.clicked.emit(event);
    }
}
